import React, { memo } from 'react'
import ControlledSelect, { IControlledSelectProps } from 'transfix-form/components/ControlledSelect'
import { TEST_IDS } from 'transfix-form/forms/SavedLaneForm/constants'
import { RATE_TYPE_OPTIONS } from '../constants'

export interface IControlledSelectRateTypeProps
  extends Pick<IControlledSelectProps, 'control' | 'name'> {}

const ControlledSelectRateType = memo<IControlledSelectRateTypeProps>(({ control, name }) => {
  return (
    <ControlledSelect
      control={control}
      name={name}
      SelectProps={{ options: RATE_TYPE_OPTIONS, large: true, dataTest: TEST_IDS.rateTypeSelect }}
    />
  )
})

export default ControlledSelectRateType
